import { render, staticRenderFns } from "./QuoteLostStateCard.vue?vue&type=template&id=2dbfcf90&"
import script from "./QuoteLostStateCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteLostStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports